export default "__VITE_ASSET__CPVpb1fX__"